import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import HardwareModel from '../components/HardwareAdmin/HardwaresPages/HardwareModel'
import Hardware from '../components/HardwareAdmin/HardwaresPages/Hardware'
import TabPanel from '../components/TabPanel';
import { FaDesktop, FaServer } from 'react-icons/fa';



function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function HardwarePage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab icon={<FaServer />} iconPosition="start" label="Modelos de Hardware" {...a11yProps(0)} />
          <Tab icon={<FaDesktop />} iconPosition="start" label="Hardware" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} style={{padding: "5px"}}>
        <HardwareModel/>
      </TabPanel>
      <TabPanel value={value} index={1} style={{padding: "5px"}}>
        <Hardware/>
      </TabPanel>
    </Box>
  );
}